import { render, staticRenderFns } from "./OrderDelivery.vue?vue&type=template&id=3e4e0a49&scoped=true"
import script from "./OrderDelivery.vue?vue&type=script&lang=js"
export * from "./OrderDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e0a49",
  null
  
)

export default component.exports